module.exports = __webpack_public_path__ + "public/img/img_hb.1c503939.png";